module.exports = __webpack_public_path__ + "img/peipao-bg.aedc7510.png";